import { render, staticRenderFns } from "./ReserveStage3.vue?vue&type=template&id=12c1e4a6&scoped=true&"
import script from "./ReserveStage3.vue?vue&type=script&lang=js&"
export * from "./ReserveStage3.vue?vue&type=script&lang=js&"
import style0 from "./ReserveStage3.vue?vue&type=style&index=0&id=12c1e4a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c1e4a6",
  null
  
)

export default component.exports